import React, { useEffect, useState } from 'react';
import { useSearchParams, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchClientQuotationList } from '../redux/clientQuotationReducer';
import { Card, Container, Row, Col, ListGroup, Tab, Nav, Button, Accordion, Table } from 'react-bootstrap';
import { Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';
import logo from "../assests/PDFlogo.png";
import logo2 from "../assests/fabc.png";
import scan from "../assests/scanner1.jpeg";
import scan2 from "../assests/scanner.jpeg";
import pdfline from "../assests/pdf-line.png";
import fabCuroLogo from "../assests/fabcuro.png";
import scan1 from "../assests/scanCopy.jpeg";
import MyTablePDF from './MyTablePDF';

export default function ClientPDF({ e, userDetails1 }) {

  const userDetails = e?.userDetials; // optional chaining prevents crash
  console.log('userDetails', userDetails);

  Font.register({
    family: 'League Spartan',
    src: '/fonts/LeagueSpartan-Bold.ttf'

  });

  Font.register({
    family: 'Work Sans',
    src: '/fonts/WorkSans-Regular.ttf',
  });

  const styles = StyleSheet.create({
    textBold1: {
      fontSize: 14,
      fontWeight: 'bold',
      fontFamily: 'League Spartan'
    },
      pdfline: {
          width: '10%',
          height: '3rem',
          gap:'3rem'
        },
    textBold2: {
      fontSize: 13,
      fontWeight: 'bold',
      fontFamily: 'League Spartan'
    },
    page: {
      paddingTop: 10,
      paddingBottom: 10,
      paddingHorizontal: 30,
      backgroundColor: '#f8f8f8',
      // backgroundColor: '#111111' ,
    },
    page2: {
      paddingTop: 10,
      paddingBottom: 90,
      paddingHorizontal: 30,
      position: 'relative',
      fontSize: 10,
      backgroundColor: '#f8f8f8',
    },
    footer: {
      position: 'absolute',
      bottom: 10,
      width: '100vw',
      gap: 10,
    },
    title: {

    },
    scan: {
      width: '100%',
      height: 'auto',

    },
    logo: {
      width: '30%',
      height: 'auto',
      paddingBottom: '1%'
    },
    logo12: {
      width: '45%',
      height: 'auto',
      paddingBottom: '1%'
    },
    logo22: {
      width: '25%',
      height: 'auto',
      paddingBottom: '1%'
    },

    row: {
      flexDirection: 'row',
      marginBottom: 5,
    },
    block: {

    },
    heading: {
      fontSize: 12,
      color: '#111111'
    },
    clientName: {
      fontSize: 12,
      fontWeight: 'bold',
      color: '#000000'
    },
    heading1: {
      fontSize: 25,
      color: '#154889',
      marginBottom: 5,
    },
    text1: {
      textAlign: 'left',
      fontSize: 10,
      fontWeight: 100,
      color: '#2F2E2E',
      fontFamily: 'Work Sans'
    },
    fontFamilyWorkSans: {
      fontFamily: 'Work Sans'
    },
    cell: {
      fontFamily: 'Work Sans'
    },
    text1a: {
      textAlign: 'left',
      fontSize: 12,
      fontWeight: 'bold',
      color: '#000000',

    },
    text2: {
      fontSize: 12,
      fontWeight: '100',
      color: '#2F2E2E',
    },
    text: {
      textAlign: 'left',
      textOverflow: 'ellipsis',
      fontSize: 12,
      fontWeight: 500,

      color: '#2F2E2E'
    },
    fill1: {

    },
    column:
    {
      flexDirection: 'column',
      flex: 1,
      borderWidth: 1,
      borderColor: '#bdbdbd',
      borderStyle: 'solid',
      borderRadius: 5,
      padding: 8,
      backgroundColor: '#FFFFFF',
    },
    column2:
    {
      flexDirection: 'column',
      flex: 2,
      borderWidth: 1,
      borderColor: '#bdbdbd',
      borderStyle: 'solid',
      borderRadius: 5,
      padding: 1,
      backgroundColor: '#FFFFFF',
    },
    column3:
    {
      flexDirection: 'column',
      flex: 1,
      borderWidth: 1,
      borderColor: '#bdbdbd',
      borderStyle: 'solid',
      borderRadius: 5,
      padding: 1,
      backgroundColor: '#FFFFFF',
      height: '100%',
    },
    columnFirst:
    {

    },
    headingColumn:
    {
      flexDirection: 'column',
      flex: 1,
      height: 50,
      borderWidth: 1,
      borderColor: '#bdbdbd',
      borderStyle: 'solid',
      borderRadius: 5,
      padding: 8,
      backgroundColor: '#FFFFFF'
    },
    logoColumn:
    {
      flexDirection: 'column',
      flex: 1,
      padding: 8,
    },
    table: {

    },
    tableRow: {

    },
    tableCell: {

    },
    pageNumber: {
      position: 'absolute',

      bottom: 10,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey',
    },
    separator: {
      flexDirection: 'row',
      paddingTop: 5,
      paddingHorizontal: 30,
      borderTopWidth: 1,
      borderTopStyle: 'solid', // React Native may not support `borderTopStyle` on some platforms; consider using `borderStyle` instead
      borderTopColor: '#2f2f2e',
    },
    tableCellLeft: {
      width: "25%",
      borderRightWidth: 1,
      borderColor: "#000000",
      padding: 8,
      fontSize: 10,
      textAlign: "center",
    },

    tableCellCenter: {
      width: "20%",
      borderRightWidth: 1,
      borderColor: "#000000",
      padding: 8,
      fontSize: 10,
      textAlign: "center",
    },

    tableCellRight: {
      width: "55%",
      padding: 8,
      fontSize: 10,
      textAlign: "left",
    }


  });





  const bankConfigs = {
    kkt: {
      bankName: "ICICI BANK",
      accountNo: "748605000779",
      ifsc: "ICIC0007486",
      branchName: "KALYAN NAGAR",
      image: scan2, // your KKT image
    },
    blr: {
      bankName: "The Federal Bank Limited",
      accountNo: "14715500000507",
      ifsc: "FDRL0001471",
      branchName: "Banaswadi",
      image: scan, // your BLR image
    },
  };

  const [bankDetails, setBankDetails] = useState(null);

  useEffect(() => {
    if (!userDetails1) return;

    const location = userDetails1?.location?.toLowerCase();

    if (location === "kkt") {
      setBankDetails(bankConfigs.kkt);
    } else {
      setBankDetails(bankConfigs.blr);
    }
  }, [userDetails1]);

  console.log("bankDetails", bankDetails);





  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        <Image style={[styles.logo, { marginBottom: '1%' }]} src={logo} />
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 6, // replaces marginBottom: '1%'
          }}
        >
          {/* Tagline text */}
          <Text style={[styles.text1, { marginBottom: 1 }]}>
            You are about to experience creativity and commitment at its best.
          </Text>

          {/* Quotation title */}
          <Text
            style={{
              fontSize: 12,
              fontWeight: 'bold',
              color: 'red',
              borderWidth: 1,
              borderColor: 'red',
              padding: 4,
              borderRadius: 4,
              textAlign: 'center',
            }}
          >
            Quotation For QC
          </Text>
        </View>

        <View
          style={{
            borderBottomColor: '##afafaf',
            borderBottomWidth: 0.5,
            marginBottom: 10,
          }}
        />
        <Text style={[styles.textBold1, { marginBottom: '1%', marginLeft: 12, }]} >Hi {e.clientDetails.cname} & Family,</Text>
        <Text style={[styles.text1, { marginBottom: '1%', marginLeft: 12, }]} >Here is the quote that you requested. Please review and reach out to us, for any questions.</Text>
        <View style={{ flexDirection: 'row', gap: 2, marginTop: 10, marginBottom: 20 }}>
          <View
            style={{
              borderBottomColor: '#ff6619',
              borderBottomWidth: 3,
              width: '10%',
              marginBottom: 6,
              marginRight: 12,
              marginLeft: 12,
            }}
          />
          <Text style={[styles.textBold2, { marginBottom: 1 }]}>
            Project Details
          </Text>
        </View>

        {/* Customber Details */}
        <View style={{ position: 'relative', width: '100%', marginBottom: 15 }}>
          {/* Shadow */}
          <View
            style={{
              position: 'absolute',
              top: 4,
              left: 11,
              width: '96%',
              backgroundColor: '#f0f0f0', // semi-transparent shadow
              borderRadius: 10,
              height: '100%',
              zIndex: 1,
            }}
          />

          {/* Main Card */}
          <View
            style={{
              width: '96%',
              backgroundColor: '#ffffff',
              marginLeft: 7,
              borderRadius: 5,
              padding: 10,
              flexDirection: 'row',
              justifyContent: 'space-eveny', // Use start alignment
              alignItems: 'center',

              flexWrap: 'wrap',
              zIndex: 0,
            }}
          >
            {/* Repeating block — each item takes 25% (1/4th) of the width */}
            <View style={{ width: '25%', padding: 7 }}>
              <Text style={[styles.text1, { marginBottom: 5 }]}>DESIGN CONSULTANT</Text>
              <Text style={[styles.fontFamilyWorkSans, { fontSize: 9, color: '#000000', fontWeight: 'bold' }]}>{e?.clientDetails.createdBy}</Text>

            </View>

            <View style={{ width: '25%', padding: 7 }}>
              <Text style={[styles.text1, { marginBottom: 5 }]}>INCREMENT</Text>
              <Text style={[styles.fontFamilyWorkSans, { fontSize: 9, color: '#000000', fontWeight: 'bold' }]}> {e.clientDetails.increment}% </Text>

            </View>

            <View style={{ width: '25%', padding: 7 }}>
              <Text style={[styles.text1, { marginBottom: 5 }]}>QUOTE VERSION</Text>
              <Text style={[styles.fontFamilyWorkSans, { fontSize: '8', color: '#000000', fontWeight: 'bold', paddingRight: 5, }]}>{e?.quotationName}</Text>
            </View>

            <View style={{ width: '10%', padding: 7 }}>
              <Text style={[styles.text1, { marginBottom: 5 }]}>DATE</Text>
              <Text style={[styles.fontFamilyWorkSans, { fontSize: 9, color: '#000000', fontWeight: 'bold' }]}>{e?.clientDetails?.date}</Text>
            </View>

            <View style={{ width: '25%', padding: 7 }}>
              <Text style={[styles.text1, { marginBottom: 5 }]}>PROPERTY NAME </Text>
              <Text style={[styles.fontFamilyWorkSans, { fontSize: 9, color: '#000000', fontWeight: 'bold' }]}>{e?.clientDetails.pname}</Text>

            </View>

            <View style={{ width: '25%', padding: 7 }}>
              <Text style={[styles.text1, { marginBottom: 5 }]}>CONFIGURATION</Text>
              <Text style={[styles.fontFamilyWorkSans, { fontSize: 9, color: '#000000', fontWeight: 'bold' }]}>{e?.clientDetails.configuration}</Text>

            </View>

            <View style={{ width: '25%', padding: 7 }}>
              <Text style={[styles.text1, { marginBottom: 5 }]}>NUMBER</Text>
              <Text style={[styles.fontFamilyWorkSans, { fontSize: 9, color: '#000000', fontWeight: 'bold' }]}>{e?.clientDetails.cphone}</Text>
            </View>

            <View style={{ width: '25%', padding: 7 }}>
              <Text style={[styles.text1, { marginBottom: 5 }]}>EMAIL</Text>
              <Text style={[styles.fontFamilyWorkSans, { fontSize: 9, color: '#000000', fontWeight: 'bold' }]}>{e?.clientDetails.cemail}</Text>
            </View>

            <View style={{ width: 'auto', padding: 7 }}>
              <Text style={[styles.text1, { marginBottom: 5 }]}>ADDRESS</Text>
              <Text style={[styles.fontFamilyWorkSans, { fontSize: 9, color: '#000000', fontWeight: 'bold' }]}>{e?.clientDetails.city}</Text>

            </View>
          </View>

        </View>

        <View style={{
          flexDirection: 'row',
          display: 'flex',
          justifyContent: 'space-between',
          gap: 20,
          marginBottom: 20,
        }}>
          {/* ROOM NAME */}
          <View style={{ position: 'relative', width: '50%', }}>
            {/* Shadow */}
            <View
              style={{
                position: 'absolute',
                top: 4,
                width: '100%',
                height: '45vh',
                backgroundColor: '#f0f0f0', // semi-transparent shadow
                borderRadius: 5,
                zIndex: 1,
              }}
            />

            {/* Main Card */}
            <View
              style={{
                width: '99%',
                height: '45vh',
                backgroundColor: '#ffffff',
                position: 'relative',
                borderRadius: 5,
                padding: 14,
                zIndex: 0,
              }}
            >
              <View
                style={[styles.textBold2, {
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: 10
                }]} >
                <Text>ROOM NAME</Text>
                <Text>TOTAL</Text>
              </View>
              {
                e.quotationData.map((item, index) => (
                  <View
                    key={index}
                    style={[styles.text1, {
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: 10
                    }]} >
                    <Text>{item.roomTypeName || ''}</Text>
                    <Text>{item.roomTypePrice != null ? item.roomTypePrice : ''}</Text>
                  </View>
                ))
              }
              {/* <View
                style={[styles.textBold2, {
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }]} >
                <Text>ROOM NAME</Text>
                <Text>TOTAL</Text>
              </View>
              <View
                style={[styles.text1, {
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginTop: 10
                }]} >
                <Text>Living Area- Console Unit</Text>
                <Text>2515151</Text>
              </View>
              <View
                style={[styles.text1, {
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginTop: 10
                }]} >
                <Text>Living Area- Console Unit</Text>
                <Text>2515151</Text>
              </View>
              <View
                style={[styles.text1, {
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginTop: 10
                }]} >
                <Text>Living Area- Console Unit</Text>
                <Text>2515151</Text>
              </View>
              <View
                style={[styles.text1, {
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginTop: 10
                }]} >
                <Text>Living Area- Console Unit</Text>
                <Text>2515151</Text>
              </View> */}

            </View>
          </View>


          <View style={{
            gap: 1,
            width: '50%'
          }}>
            {/* GROSS TOTAL */}
            <View style={{ position: 'relative', width: '100%', height: 'auto' }}>
              {/* Shadow */}
              <View style={{
                position: 'absolute',
                top: 4,
                width: '100%',
                height: '23vh',
                backgroundColor: '#f0f0f0', // semi-transparent shadow
                borderRadius: 5,
                zIndex: 1,
              }}
              />

              {/* Main Card */}
              <View
                style={{
                  width: '99%',
                  height: 'auto',
                  backgroundColor: '#ffffff',
                  padding: 10,
                  borderRadius: 5,
                }}
              >
                {/* Content goes here */}
                <View style={{
                  padding: 5,
                  flexDirection: 'row',
                  flex: 1,
                  alignItems: 'center',
                  gap: 50,
                  justifyContent: 'space-between',
                  marginBottom: 30
                }}>
                  <Text style={[styles.textBold2, { marginLeft: 50, marginTop: 14, }]}>GROSS TOTAL</Text>
                </View>
                <View style={{
                  padding: 5,
                  flexDirection: 'row',
                  flex: 1,
                  alignItems: 'center',
                  gap: 50,
                  justifyContent: 'space-between',
                  marginBottom: 10
                }}>
                  <Text style={[styles.text1, { marginBottom: 2 }]}>Total  </Text>
                  <Text style={{ fontSize: 9, color: '#000000', fontWeight: 'bold', }}>INR {e.quotationPrice}</Text>
                </View>
                <View
                  style={{
                    borderBottomColor: '#f0f0f0',
                    borderBottomWidth: 1,
                    marginBottom: 20,
                  }}
                />

                <View style={{
                  padding: 5,
                  flexDirection: 'row',
                  flex: 1,
                  alignItems: 'center',
                  gap: 50,
                  justifyContent: 'space-between',
                  marginBottom: 10
                }}>
                  <Text style={[styles.text1, { marginBottom: 15 }]}>Wood Work  </Text>
                  <Text style={{ fontSize: 9, color: '#000000', fontWeight: 'bold', marginBottom: 15 }}>INR {e.quotationWood}</Text>

                </View>
                {e.quotationDiscount !== 0 && <View style={{
                  padding: 5,
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 10,
                  width: '100%',
                }}>
                  <View>
                    <Text style={[styles.text1, { marginBottom: 2, flexWrap: 'wrap', }]}>Discount ({e.quotationDiscount}%)</Text>
                    <Text style={[{ fontSize: '6px', color: '#000000', fontWeight: 'bold' }]}> Applied on woodwork only</Text>
                  </View>
                  <View>

                    <Text style={{ fontSize: 9, color: '#000000', fontWeight: 'bold', paddingLeft: 15 }}>INR {Math.round(e.quotationWood * (e.quotationDiscount / 100))}</Text>
                  </View>

                </View>}



                {/* coupon discount  */}

                {/* <View style={{
                  padding: 1,
                  flexDirection: 'row',
                  flex: 1,
                  alignItems: 'center',
                  gap: 50,
                  justifyContent: 'space-between',
                   marginBottom: 10
                }}>
                  <View style={{
                  paddingBottom: 20,
                  marginBottom: 20
                }}>
                  <Text style={[styles.text1, { flexShrink: 1 }]}>Discount {e.quotationDiscount}% </Text>
                  <Text style={{ fontSize: 8}} >Applied on woodwork only </Text>
                  </View>
                  <Text style={{ fontSize: 9, color: '#000000', fontWeight: 'bold' }}>{e.quotationDiscount}%</Text>
                </View> */}


                <View
                  style={{
                    borderBottomColor: '#f0f0f0',
                    borderBottomWidth: 1,
                    marginBottom: 15,
                  }}
                />

                <View style={{
                  padding: 4,
                  flexDirection: 'row',
                  flex: 1,
                  alignItems: 'center',
                  textAlign: 'center',
                  gap: 35,
                  justifyContent: 'space-between',
                  marginBottom: 10
                }}>
                  <Text style={[styles.text1, { flexShrink: 1 }]}>Discounted Final </Text>
                  <Text style={{ fontSize: 9, color: '#000000', fontWeight: 'bold' }}>
                    INR {Math.round(
                      (Number(e.quotationPrice) || 0) -
                      (Number(e?.quotationSpecialDiscount) || 0) -
                      (Number(e.quotationWood) || 0) * ((Number(e.quotationDiscount) || 0) / 100)
                    )}
                  </Text>
                </View>

                <View
                  style={{
                    borderBottomColor: '#f0f0f0',
                    borderBottomWidth: 1,
                    marginBottom: 15,
                  }}
                />


                <View style={{
                  padding: 5,
                  flexDirection: 'row',
                  flex: 1,
                  alignItems: 'center',
                  gap: 50,
                  justifyContent: 'space-between',
                  marginBottom: 3
                }}>
                  <Text style={[styles.text1, { flexShrink: 1 }]}>Grand Total with GST ({e.quotationTaxation}%) </Text>
                  <Text style={{ fontSize: 9, color: '#000000', fontWeight: 'bold' }}>INR {Math.round((e.quotationPrice - (e?.quotationSpecialDiscount || 0) - (e.quotationWood * (e.quotationDiscount / 100))) + ((e.quotationPrice - (e?.quotationSpecialDiscount || 0) - (e.quotationWood * (e.quotationDiscount / 100))) * (e.quotationTaxation || 18) / 100))}</Text>
                </View>
                <View
                  style={{
                    borderBottomColor: '#f0f0f0',
                    borderBottomWidth: 1,
                    marginBottom: 15,
                  }}
                />


                {/* <View style={{
                  padding: 5,
                  flexDirection: 'row',
                  flex: 1,
                  alignItems: 'center',
                  gap: 50,
                  justifyContent: 'space-between',
                  marginBottom: 3
                }}>
                  <Text style={[styles.text1, { flexShrink: 1 }]}>Grand Total with {"\n"}Additional Discount </Text>
                  <Text style={{ fontSize: 9, color: '#000000', fontWeight: 'bold' }}>  INR {Math.round(
                    (e.quotationPrice - (e?.quotationSpecialDiscount || 0) - (e.quotationWood * (e.quotationDiscount / 100))) +
                    ((e.quotationPrice - (e?.quotationSpecialDiscount || 0) - (e.quotationWood * (e.quotationDiscount / 100))) *
                      (e.quotationTaxation || 18) / 100) - 8704
                  )}</Text>
                </View> */}

              </View>
            </View>

            {/* PAYMENT BREAKUP */}
            {/* <View style={{ width: '100%', marginTop: 10 ,backgroundColor:'white',padding:10,borderRadius:5 ,height:'17vh'}}>

              <Text style={[styles.textBold2, { marginBottom: 10, textAlign: 'center' }]}>
                PAYMENT BREAKUP
              </Text>

              {[
                { label: 'Commitment Advance', value: '10%' },
                { label: 'Production Advance', value: '40% + GST as applied' },
                { label: 'Material Delivery', value: '40%' },
                { label: 'On Handover', value: '10%' },
              ].map((item, index) => (
                <View
                  key={index}
                  style={{
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    paddingVertical: 10,
                  }}
                >
                  <Text style={styles.text1}>{item.label}</Text>

         
                  <View style={{ alignItems: 'flex-end', width: 120 ,paddingRight:10}}>
                    {Array.isArray(item.value) ? (
                      item.value.map((v, i) => (
                        <Text key={i} style={{ fontSize: 9, fontWeight: 'bold', color: '#000' }}>
                          {v}
                        </Text>
                      ))
                    ) : (
                      <Text style={{ fontSize: 9, fontWeight: 'bold', color: '#000' }}>
                        {item.value}
                      </Text>
                    )}
                  </View>
                </View>
              ))}

            </View> */}

          </View>
        </View>
        <View
          style={{
            borderBottomColor: '#b0b0b0',
            borderBottomWidth: 0.5,
            marginBottom: 2,
            marginTop: 10,
            width: '100%', // or use a fixed width like 200
            alignSelf: 'center', // to center the line horizontally
            paddingLeft: 10, // optional; remove if not needed
          }}
        />
        <View
          style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 35, }}
        >
          {/* Left Section */}
          <View >
            <Text style={[styles.textBold1]}>FABDIZ DESIGN STUDIO</Text>
            <Text style={[styles.text1]}>Bangalore | Kolkata | Chennai</Text>
            <Text style={[styles.text1, { marginTop: 2 }]}>GST: 29AAHFI9133P1ZM</Text>
          </View>

          {/* Divider */}
          <View style={{ borderLeftColor: 'black', borderLeftWidth: 0.5, marginLeft: 55, height: 45, paddingRight: 30, paddingLeft: 30 }} />

          {/* Right Section */}
          <View >
            <Image style={[styles.logo, { width: 80 }]} src={fabCuroLogo} />
            <Text style={[styles.text1]}>
              The premium decor store - a FABDIZ initiative.{'\n'} Now shipping pan India
            </Text>
            <Text
              style={[styles.text1, { fontSize: 10, fontWeight: 'bold', marginTop: 4 }]}
              render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
              fixed
            />
          </View>
        </View>

      </Page>

      <Page size="A4" style={styles.page2} wrap>

        {/* HEADER (fixed once per doc or repeating if needed) */}
        <View style={styles.header} fixed>
          <Image style={[styles.logo, { marginBottom: 4 }]} src={logo} />
          <Text style={[styles.text1, { marginBottom: 4 }]}>
            You are about to experience creativity and commitment at its best.
          </Text>
          <View style={{ borderBottomColor: '#afafaf', borderBottomWidth: 0.5, marginBottom: 20 }} />
        </View>

        {/* FOOTER */}
        <View style={styles.footer} fixed>
          <View
            style={{
              borderBottomColor: 'black',
              borderBottomWidth: 0.5,
              marginTop: 15,
              width: '90%', // or use a fixed width like 200
              alignSelf: 'center', // to center the line horizontally
              paddingLeft: 10, // optional; remove if not needed
            }}
          />

          <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 35, }}>
            {/* Left Section */}
            <View style={{ paddingLeft: 35 }}>
              <Text style={[styles.textBold1]}>FABDIZ DESIGN STUDIO</Text>
              <Text style={[styles.text1]}>Bangalore | Kolkata | Chennai</Text>
              <Text style={[styles.text1, { marginTop: 2 }]}>GST: 29AAHFI9133P1ZM</Text>
            </View>

            {/* Divider */}
            <View style={{ borderLeftColor: 'black', borderLeftWidth: 0.5, marginLeft: 55, height: 45, paddingRight: 30, paddingLeft: 30 }} />

            {/* Right Section */}
            <View style={{ flex: 4 }}>
              <Image style={[styles.logo, { width: 80 }]} src={fabCuroLogo} />
              <Text style={[styles.text1]}>  The premium decor store - a FABDIZ initiative. Now shipping pan India  </Text>
              <Text style={[styles.text1, { fontSize: 10, fontWeight: 'bold', marginTop: 4 }]}
                render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
                fixed
              />
            </View>
          </View>
        </View>

        {/* CONTENT: loop all quotation sections continuously */}
        {e.quotationData.map((item, idx) => (
          <View key={idx} style={{ marginBottom: 12 }} wrap>

            {/* Section Title */}
             <View style={{ flexDirection: 'row',alignItems: 'center' }}>
                <Image style={[styles.pdfline, { marginBottom: 4 }]} src={pdfline} />
                <Text style={[styles.textBold2, { marginLeft: 8 }]}>{item.roomTypeName}</Text>
              </View>


            {/* Header Row */}

            <View style={{
              backgroundColor: '#ffffff',
              borderRadius: 8,
              padding: 5,
              // marginHorizontal: 8,

              shadowColor: '#000',
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.1,
              shadowRadius: 4,

              elevation: 4,
              width: '100%'
            }}>
              <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly', backgroundColor: "#d9d9db", width: '100%', padding: 5, borderRadius: 5 }}>
                <Text style={[{ width: 80, fontWeight: 'bold', fontSize: 11 }]}>Name</Text>
                <Text style={[{ width: 80, fontWeight: 'bold', fontSize: 11, textAlign: 'left' }]}>Finish</Text>
                {
                  e.quotationpermission ? (
                    <>
                      {e.quotationpermission.width && (
                        <View>

                          <Text style={[{ width: 40, fontWeight: 'bold', fontSize: 8 }]}>Dimension</Text>
                          <Text style={[{ width: 40, fontWeight: 'bold', fontSize: 8 }]}>(W × H × D)</Text>
                        </View>
                      )}
                      {/* {e.quotationpermission.height && (
                        <Text style={[ { width: 40, fontWeight: 'bold', fontSize: 10 }]}>Height</Text>
                      )} */}
                      {e.quotationpermission.area && (
                        <View>
                          <Text style={[{ width: 50, fontWeight: 'bold', fontSize: 9, textAlign: 'center', paddingLeft: 10 }]}>Area</Text>
                          <Text style={[{ width: 50, fontWeight: 'bold', fontSize: 8, textAlign: 'center', paddingLeft: 10 }]}>(Sqft/Rft)</Text>
                        </View>
                      )}
                    </>
                  ) : (
                    <>
                      <Text style={[{ width: 40, fontWeight: 'bold', fontSize: 10 }]}>Width</Text>
                      <Text style={[{ width: 40, fontWeight: 'bold', fontSize: 10 }]}>Height</Text>
                      <Text style={[{ width: 50, fontWeight: 'bold', fontSize: 10, textAlign: 'center' }]}>Area{'\n'}(Sqft/Rft)</Text>
                    </>
                  )
                }
                <View>
                  <Text style={[{ width: 30, fontWeight: 'bold', fontSize: 9, textAlign: 'center', paddingLeft: 10 }]}>Qty</Text>
                  <Text style={[{ width: 30, fontWeight: 'bold', fontSize: 8, textAlign: 'center', paddingLeft: 10 }]}>(Nos)</Text>
                </View>
                <Text style={[{ width: 50, fontWeight: 'bold', fontSize: 9, textAlign: 'center', paddingLeft: 10 }]}>Base Price</Text>
                <Text style={[{ width: 55, fontWeight: 'bold', fontSize: 9, textAlign: 'center', paddingLeft: 10 }]}>Increment Price</Text>
                <Text style={[{ width: 50, fontWeight: 'bold', fontSize: 9, textAlign: 'center', paddingLeft: 6 }]}>Price</Text>
                <Text style={[{ width: 50, fontWeight: 'bold', fontSize: 9, textAlign: 'center', paddingLeft: 6 }]}>Discount Price</Text>
                <Text style={[{ width: 70, fontWeight: 'bold', fontSize: 9, textAlign: 'left', paddingLeft: 5 }]}>Remark</Text>
              </View>

              {/* Divider */}
              <View style={{ borderBottomColor: '#afafaf', borderBottomWidth: 0.5, marginBottom: 4, marginTop: 4 }} />

              {/* Rows */}
              {item.title?.map((item2, i2) => {

                // 1️⃣ Case: Wardrobe - Slider with value2 > 0
                if (item2.value2 > 0 && item2.name === "Wardrobe - Slider") {
                  return (
                    <View key={i2}>
                      <View style={{ flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center' }} wrap>
                        <Text style={[styles.cell, { width: 80, flexWrap: 'wrap', paddingRight: 10 }]}>
                          {item2.name}
                          {/* {item2.height && item2.width && (
                                                        <Text> (Area)</Text>
                                                    )} */}
                          {/* {item2.rft && (
                                                        <Text> (Rft)</Text>
                                                    )} */}
                          {/* {item2.height === '' &&
                                                        item2.area === '' &&
                                                        item2.rft === '' &&
                                                        item2.width === '' &&
                                                        item2.qnty !== '' && (
                                                            <Text> (Qnty)</Text>
                                                        )} */}
                          {/* {item2.height === '' &&
                                                        item2.qnty === '' &&
                                                        item2.rft === '' &&
                                                        item2.width === '' &&
                                                        item2.area !== '' && (
                                                            <Text> (Area)</Text>
                                                        )} */}
                        </Text>

                        <Text style={[styles.cell, { width: 50, flexWrap: 'wrap', textAlign: 'left' }]}>{item2.label}</Text>

                        {e.quotationpermission ? (
                          <>
                            {e.quotationpermission.width && (
                              <Text style={[styles.cell, { width: 60, textAlign: 'center', paddingLeft: 1 }]}>
                                {(() => {
                                  // Hide if all dimensions are empty and qnty or rft > 0
                                  if (
                                    (item2.width === '' && item2.height === '' && item2.depth === '' && item2.qnty > 0) ||
                                    item2.rft > 0
                                  ) {
                                    return '';
                                  }

                                  // Show all three dimensions if depth exists
                                  if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                    return `${item2.width} × ${item2.height} × ${item2.depth}`;
                                  }

                                  // Show width × height if only those exist
                                  if (item2.width > 0 && item2.height > 0) {
                                    return `${item2.width} × ${item2.height}`;
                                  }

                                  // Otherwise, empty
                                  return '';
                                })()}
                              </Text>
                            )}
                            {/* {e.quotationpermission.height && <Text style={[styles.cell, { width: 40, textAlign: 'center', paddingLeft: 25 }]}>{item2.height > 0 ? item2.height : ''}</Text>} */}
                            {e.quotationpermission.area && <Text style={[styles.cell, { width: 50, textAlign: 'center' }]}>
                              {(() => {
                                let value = 0;

                                if (item2.area > 0) {
                                  value = item2.area;
                                } else if (item2.rft > 0) {
                                  value = item2.rft;
                                } else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                  // Cove light calculation
                                  value =
                                    (item2.width * item2.depth * 2) +
                                    ((item2.height - (item2.depth * 2)) * item2.depth * 2) +
                                    (
                                      (
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2)) +
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2))
                                      ) * 3
                                    );
                                } else if (item2.width > 0 && item2.height > 0) {
                                  value = item2.width * item2.height;
                                }

                                return value ? Number(value.toFixed(2)) : '';
                              })()}

                            </Text>
                            }
                          </>
                        ) : (
                          <>
                            <Text style={[styles.cell, { width: 40, textAlign: 'center', paddingLeft: 25 }]}>{item2.width > 0 ? item2.width : ''}</Text>
                            <Text style={[styles.cell, { width: 40, textAlign: 'center', paddingLeft: 25 }]}>{item2.height > 0 ? item2.height : ''}</Text>
                            <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 25 }]}>
                              {(() => {
                                let value = 0;

                                if (item2.area > 0) {
                                  value = item2.area;
                                } else if (item2.rft > 0) {
                                  value = item2.rft;
                                } else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                  // Cove light calculation
                                  value =
                                    (item2.width * item2.depth * 2) +
                                    ((item2.height - (item2.depth * 2)) * item2.depth * 2) +
                                    (
                                      (
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2)) +
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2))
                                      ) * 3
                                    );
                                } else if (item2.width > 0 && item2.height > 0) {
                                  value = item2.width * item2.height;
                                }

                                return value ? Number(value.toFixed(2)) : '';
                              })()}

                            </Text>

                          </>
                        )}

                        <Text style={[styles.cell, { width: 30, textAlign: 'center', paddingLeft: 1 }]}>{item2.qnty > 0 ? item2.qnty : ''}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 1 }]}>{item2.price > 0 ? item2.value : ''}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 1 }]}>{item2.price > 0 && item2.type == 'nonwoodwork' || item2.type == '' ? item2.value : item2.valueIncresed}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center' }]}>{(item2.width || item2.height || item2.area) && item2.price > 0 ? item2.price : ''}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 1 }]}>{item2.price > 0 && item2.type == 'woodwork' ? Math.round(item2.price -(item2.price * (e.quotationDiscount / 100))) : null}</Text>
                        <Text style={[styles.cell, { width: 70, flexWrap: 'wrap', textAlign: 'left' }]}>{item2.remark}</Text>
                      </View>
                      <View style={{ borderBottomColor: '#afafaf', borderBottomWidth: 0.5, marginVertical: 4 }} />
                    </View>
                  );
                }

                // 2️⃣ Case: Shape Of Kitchen OR price > 0
                else if (item2.label != '' && item2.name === "Shape Of Kitchen") {
                  return (
                    <View key={i2}>
                      <View style={{ flexDirection: 'row', alignItems: 'flex-start', paddingLeft: 5 }} wrap>
                        <Text style={[styles.cell, { width: 80, flexWrap: 'wrap', paddingRight: 10 }]}>{item2.name}
                          {/* {item2.height && item2.width && (
                                                    <Text> (Area)</Text>
                                                )} */}
                          {/* {item2.rft && (
                                                        <Text> (Rft)</Text>
                                                    )} */}
                          {/* {item2.height === '' &&
                                                        item2.area === '' &&
                                                        item2.rft === '' &&
                                                        item2.width === '' &&
                                                        item2.qnty !== '' && (
                                                            <Text> (Qnty)</Text>
                                                        )} */}
                          {/* {item2.height === '' &&
                                                        item2.qnty === '' &&
                                                        item2.rft === '' &&
                                                        item2.width === '' &&
                                                        item2.area !== '' && (
                                                            <Text> (Area)</Text>
                                                        )} */}
                        </Text>
                        <Text style={[styles.cell, { width: 70, flexWrap: 'wrap', textAlign: 'left' }]}>{item2.label}</Text>

                        {e.quotationpermission ? (
                          <>
                            {e.quotationpermission.width && (
                              <Text style={[styles.cell, { width: 60, textAlign: 'center', paddingLeft: 1 }]}>
                                {(() => {
                                  // Hide if all dimensions are empty and qnty or rft > 0
                                  if (
                                    (item2.width === '' && item2.height === '' && item2.depth === '' && item2.qnty > 0) ||
                                    item2.rft > 0
                                  ) {
                                    return '';
                                  }

                                  // Show all three dimensions if depth exists
                                  if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                    return `${item2.width} × ${item2.height} × ${item2.depth}`;
                                  }

                                  // Show width × height if only those exist
                                  if (item2.width > 0 && item2.height > 0) {
                                    return `${item2.width} × ${item2.height}`;
                                  }

                                  // Otherwise, empty
                                  return '';
                                })()}
                              </Text>
                            )}
                            {/* {e.quotationpermission.height && <Text style={[styles.cell, { width: 40, textAlign: 'center' }]}>{item2.height > 0 ? item2.height : ''}</Text>} */}
                            {e.quotationpermission.area && <Text style={[styles.cell, { width: 50, textAlign: 'center' }]}>
                              {(() => {
                                let value = 0;

                                if (item2.area > 0) {
                                  value = item2.area;
                                } else if (item2.rft > 0) {
                                  value = item2.rft;
                                } else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                  // Cove light calculation
                                  value =
                                    (item2.width * item2.depth * 2) +
                                    ((item2.height - (item2.depth * 2)) * item2.depth * 2) +
                                    (
                                      (
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2)) +
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2))
                                      ) * 3
                                    );
                                } else if (item2.width > 0 && item2.height > 0) {
                                  value = item2.width * item2.height;
                                }

                                return value ? Number(value.toFixed(2)) : '';
                              })()}

                            </Text>
                            }
                          </>
                        ) : (
                          <>
                            <Text style={[styles.cell, { width: 40, textAlign: 'center' }]}>{item2.width > 0 ? item2.width : ''}</Text>
                            <Text style={[styles.cell, { width: 40, textAlign: 'center' }]}>{item2.height > 0 ? item2.height : ''}</Text>
                            <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 25 }]}>
                              {(() => {
                                let value = 0;

                                if (item2.area > 0) {
                                  value = item2.area;
                                } else if (item2.rft > 0) {
                                  value = item2.rft;
                                } else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                  // Cove light calculation
                                  value =
                                    (item2.width * item2.depth * 2) +
                                    ((item2.height - (item2.depth * 2)) * item2.depth * 2) +
                                    (
                                      (
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2)) +
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2))
                                      ) * 3
                                    );
                                } else if (item2.width > 0 && item2.height > 0) {
                                  value = item2.width * item2.height;
                                }

                                return value ? Number(value.toFixed(2)) : '';
                              })()}

                            </Text>

                          </>
                        )}

                        <Text style={[styles.cell, { width: 30, textAlign: 'center' }]}>{item2.qnty > 0 ? item2.qnty : ''}</Text>
                        {/* <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 1 }]}>{item2.price > 0 ? item2.value : ''}</Text> */}
                        {/* <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 1 }]}>{item2.price > 0 && item2.type == 'nonwoodwork' || item2.type == '' ? item2.value : item2.valueIncresed}</Text> */}
                        {/* <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 1 }]}>{item2.price > 0 && item2.type == 'woodwork' ? Math.round(item2.valueIncresed*(e.quotationDiscount/100)): null}</Text> */}
                        {/* <Text style={[styles.cell, { width: 50, textAlign: 'center' }]}>{item2.price}</Text> */}
                        <Text style={[styles.cell, { width: 70, flexWrap: 'wrap', textAlign: 'left' }]}>{item2.remark}</Text>
                      </View>
                      <View style={{ borderBottomColor: '#afafaf', borderBottomWidth: 0.5, marginVertical: 4 }} />
                    </View>
                  );
                }

                // 3️⃣ Case: price > 0
                else if (item2.price > 0) {
                  return (
                    <View key={i2}>
                      <View style={{ flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center' }} wrap>
                        <Text style={[styles.cell, { width: 80, flexWrap: 'wrap', paddingRight: 10 }]}>{item2.name}

                          {/* {item2.height && item2.width && (
                                                    <Text> (Area)</Text>
                                                )} */}
                          {/* {item2.rft && (
                                                        <Text> (Rft)</Text>
                                                    )} */}
                          {/* {item2.height === '' &&
                                                        item2.area === '' &&
                                                        item2.rft === '' &&
                                                        item2.width === '' &&
                                                        item2.qnty !== '' && (
                                                            <Text> (Qnty)</Text>
                                                        )} */}
                          {/* {item2.height === '' &&
                                                        item2.qnty === '' &&
                                                        item2.rft === '' &&
                                                        item2.width === '' &&
                                                        item2.area !== '' && (
                                                            <Text> (Area)</Text>
                                                        )} */}
                        </Text>
                        <Text style={[styles.cell, { width: 70, flexWrap: 'wrap', textAlign: 'left' }]}>{item2.label}</Text>

                        {e.quotationpermission ? (
                          <>
                            {e.quotationpermission.width && (
                              <Text style={[styles.cell, { width: 60, textAlign: 'center', paddingLeft: 1 }]}>
                                {(() => {
                                  // Hide if all dimensions are empty and qnty or rft > 0
                                  if (
                                    (item2.width === '' && item2.height === '' && item2.depth === '' && item2.qnty > 0) ||
                                    item2.rft > 0
                                  ) {
                                    return '';
                                  }

                                  // Show all three dimensions if depth exists
                                  if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                    return `${item2.width} × ${item2.height} × ${item2.depth}`;
                                  }

                                  // Show width × height if only those exist
                                  if (item2.width > 0 && item2.height > 0) {
                                    return `${item2.width} × ${item2.height}`;
                                  }

                                  // Otherwise, empty
                                  return '';
                                })()}
                              </Text>
                            )}
                            {/* {e.quotationpermission.height && <Text style={[styles.cell, { width: 40, textAlign: 'center' }]}>{item2.height > 0 ? item2.height : ''}</Text>} */}
                            {e.quotationpermission.area && <Text style={[styles.cell, { width: 50, textAlign: 'center' }]}>
                              {(() => {
                                let value = 0;

                                if (item2.area > 0) {
                                  value = item2.area;
                                } else if (item2.rft > 0) {
                                  value = item2.rft;
                                } else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                  // Cove light calculation
                                  value =
                                    (item2.width * item2.depth * 2) +
                                    ((item2.height - (item2.depth * 2)) * item2.depth * 2) +
                                    (
                                      (
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2)) +
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2))
                                      ) * 3
                                    );
                                } else if (item2.width > 0 && item2.height > 0) {
                                  value = item2.width * item2.height;
                                }

                                return value ? Number(value.toFixed(2)) : '';
                              })()}

                            </Text>
                            }
                          </>
                        ) : (
                          <>
                            <Text style={[styles.cell, { width: 40, textAlign: 'center' }]}>{item2.width > 0 ? item2.width : ''}</Text>
                            <Text style={[styles.cell, { width: 40, textAlign: 'center' }]}>{item2.height > 0 ? item2.height : ''}</Text>
                            <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 25 }]}>
                              {(() => {
                                let value = 0;

                                if (item2.area > 0) {
                                  value = item2.area;
                                } else if (item2.rft > 0) {
                                  value = item2.rft;
                                } else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                  // Cove light calculation
                                  value =
                                    (item2.width * item2.depth * 2) +
                                    ((item2.height - (item2.depth * 2)) * item2.depth * 2) +
                                    (
                                      (
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2)) +
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2))
                                      ) * 3
                                    );
                                } else if (item2.width > 0 && item2.height > 0) {
                                  value = item2.width * item2.height;
                                }

                                return value ? Number(value.toFixed(2)) : '';
                              })()}

                            </Text>

                          </>
                        )}

                        <Text style={[styles.cell, { width: 30, textAlign: 'center' }]}>{item2.qnty > 0 ? item2.qnty : ''}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 1 }]}>{item2.price > 0 ? item2.value : ''}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 1 }]}>{item2.price > 0 && item2.type == 'nonwoodwork' || item2.type == '' ? item2.value : item2.valueIncresed}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center' }]}>{item2.price}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 1 }]}>{item2.price > 0 && item2.type == 'woodwork' ? Math.round(item2.price -(item2.price * (e.quotationDiscount / 100))) : null}</Text>
                        <Text style={[styles.cell, { width: 70, flexWrap: 'wrap', textAlign: 'left' }]}>{item2.remark}</Text>
                      </View>
                      <View style={{ borderBottomColor: '#afafaf', borderBottomWidth: 0.5, marginVertical: 4 }} />
                    </View>
                  );
                }



                // 3️⃣ Case: value > 0
                else if (item2.value > 0 && item2.isUserAdded) {
                  return (
                    <View key={i2}>
                      <View style={{ flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center' }} wrap>
                        <Text style={[styles.cell, { width: 80, flexWrap: 'wrap', paddingRight: 10 }]}>{item2.name}

                          {/* {item2.height && item2.width && (
                                                    <Text> (Area)</Text>
                                                )} */}
                          {/* {item2.rft && (
                                                        <Text> (Rft)</Text>
                                                    )} */}
                          {/* {item2.height === '' &&
                                                        item2.area === '' &&
                                                        item2.rft === '' &&
                                                        item2.width === '' &&
                                                        item2.qnty !== '' && (
                                                            <Text> (Qnty)</Text>
                                                        )} */}
                          {/* {item2.height === '' &&
                                                        item2.qnty === '' &&
                                                        item2.rft === '' &&
                                                        item2.width === '' &&
                                                        item2.area !== '' && (
                                                            <Text> (Area)</Text>
                                                        )} */}
                        </Text>
                        <Text style={[styles.cell, { width: 70, flexWrap: 'wrap', textAlign: 'left' }]}>{item2.label}</Text>

                        {e.quotationpermission ? (
                          <>
                            {e.quotationpermission.width && (
                              <Text style={[styles.cell, { width: 60, textAlign: 'center', paddingLeft: 1 }]}>
                                {(() => {
                                  // Hide if all dimensions are empty and qnty or rft > 0
                                  if (
                                    (item2.width === '' && item2.height === '' && item2.depth === '' && item2.qnty > 0) ||
                                    item2.rft > 0
                                  ) {
                                    return '';
                                  }

                                  // Show all three dimensions if depth exists
                                  if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                    return `${item2.width} × ${item2.height} × ${item2.depth}`;
                                  }

                                  // Show width × height if only those exist
                                  if (item2.width > 0 && item2.height > 0) {
                                    return `${item2.width} × ${item2.height}`;
                                  }

                                  // Otherwise, empty
                                  return '';
                                })()}
                              </Text>
                            )}
                            {/* {e.quotationpermission.height && <Text style={[styles.cell, { width: 40, textAlign: 'center' }]}>{item2.height > 0 ? item2.height : ''}</Text>} */}
                            {e.quotationpermission.area && <Text style={[styles.cell, { width: 50, textAlign: 'center' }]}>
                              {(() => {
                                let value = 0;

                                if (item2.area > 0) {
                                  value = item2.area;
                                } else if (item2.rft > 0) {
                                  value = item2.rft;
                                } else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                  // Cove light calculation
                                  value =
                                    (item2.width * item2.depth * 2) +
                                    ((item2.height - (item2.depth * 2)) * item2.depth * 2) +
                                    (
                                      (
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2)) +
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2))
                                      ) * 3
                                    );
                                } else if (item2.width > 0 && item2.height > 0) {
                                  value = item2.width * item2.height;
                                }

                                return value ? Number(value.toFixed(2)) : '';
                              })()}

                            </Text>
                            }
                          </>
                        ) : (
                          <>
                            <Text style={[styles.cell, { width: 40, textAlign: 'center' }]}>{item2.width > 0 ? item2.width : ''}</Text>
                            <Text style={[styles.cell, { width: 40, textAlign: 'center' }]}>{item2.height > 0 ? item2.height : ''}</Text>
                            <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 25 }]}>
                              {(() => {
                                let value = 0;

                                if (item2.area > 0) {
                                  value = item2.area;
                                } else if (item2.rft > 0) {
                                  value = item2.rft;
                                } else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                  // Cove light calculation
                                  value =
                                    (item2.width * item2.depth * 2) +
                                    ((item2.height - (item2.depth * 2)) * item2.depth * 2) +
                                    (
                                      (
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2)) +
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2))
                                      ) * 3
                                    );
                                } else if (item2.width > 0 && item2.height > 0) {
                                  value = item2.width * item2.height;
                                }

                                return value ? Number(value.toFixed(2)) : '';
                              })()}

                            </Text>

                          </>
                        )}

                        <Text style={[styles.cell, { width: 30, textAlign: 'center' }]}>{item2.qnty > 0 ? item2.qnty : ''}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 1 }]}>{item2.price > 0 ? item2.value : ''}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 1 }]}>{item2.price > 0 && item2.type == 'nonwoodwork' || item2.type == '' ? item2.value : item2.valueIncresed}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center' }]}>{item2.value}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 1 }]}>{item2.price > 0 && item2.type == 'woodwork' ? Math.round(item2.price -(item2.price * (e.quotationDiscount / 100))) : null}</Text>
                        <Text style={[styles.cell, { width: 70, flexWrap: 'wrap', textAlign: 'left' }]}>{item2.remark}</Text>
                      </View>
                      <View style={{ borderBottomColor: '#afafaf', borderBottomWidth: 0.5, marginVertical: 4 }} />
                    </View>
                  );
                }
                // 3️⃣ Case: value > 0
                else if (item2.value > 0) {
                  return (
                    <View key={i2}>
                      <View style={{ flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center' }} wrap>
                        <Text style={[styles.cell, { width: 80, flexWrap: 'wrap', paddingRight: 10 }]}>{item2.label}

                          {/* {item2.height && item2.width && (
                                                    <Text> (Area)</Text>
                                                )} */}
                          {/* {item2.rft && (
                                                        <Text> (Rft)</Text>
                                                    )} */}
                          {/* {item2.height === '' &&
                                                        item2.area === '' &&
                                                        item2.rft === '' &&
                                                        item2.width === '' &&
                                                        item2.qnty !== '' && (
                                                            <Text> (Qnty)</Text>
                                                        )} */}
                          {/* {item2.height === '' &&
                                                        item2.qnty === '' &&
                                                        item2.rft === '' &&
                                                        item2.width === '' &&
                                                        item2.area !== '' && (
                                                            <Text> (Area)</Text>
                                                        )} */}
                        </Text>
                        <Text style={[styles.cell, { width: 70, flexWrap: 'wrap', textAlign: 'left' }]}> </Text>

                        {e.quotationpermission ? (
                          <>
                            {e.quotationpermission.width && (
                              <Text style={[styles.cell, { width: 60, textAlign: 'center', paddingLeft: 1 }]}>
                                {(() => {
                                  // Hide if all dimensions are empty and qnty or rft > 0
                                  if (
                                    (item2.width === '' && item2.height === '' && item2.depth === '' && item2.qnty > 0) ||
                                    item2.rft > 0
                                  ) {
                                    return '';
                                  }

                                  // Show all three dimensions if depth exists
                                  if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                    return `${item2.width} × ${item2.height} × ${item2.depth}`;
                                  }

                                  // Show width × height if only those exist
                                  if (item2.width > 0 && item2.height > 0) {
                                    return `${item2.width} × ${item2.height}`;
                                  }

                                  // Otherwise, empty
                                  return '';
                                })()}
                              </Text>
                            )}
                            {/* {e.quotationpermission.height && <Text style={[styles.cell, { width: 40, textAlign: 'center' }]}>{item2.height > 0 ? item2.height : ''}</Text>} */}
                            {e.quotationpermission.area && <Text style={[styles.cell, { width: 50, textAlign: 'center' }]}>
                              {(() => {
                                let value = 0;

                                if (item2.area > 0) {
                                  value = item2.area;
                                } else if (item2.rft > 0) {
                                  value = item2.rft;
                                } else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                  // Cove light calculation
                                  value =
                                    (item2.width * item2.depth * 2) +
                                    ((item2.height - (item2.depth * 2)) * item2.depth * 2) +
                                    (
                                      (
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2)) +
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2))
                                      ) * 3
                                    );
                                } else if (item2.width > 0 && item2.height > 0) {
                                  value = item2.width * item2.height;
                                }

                                return value ? Number(value.toFixed(2)) : '';
                              })()}

                            </Text>
                            }
                          </>
                        ) : (
                          <>
                            <Text style={[styles.cell, { width: 40, textAlign: 'center' }]}>{item2.width > 0 ? item2.width : ''}</Text>
                            <Text style={[styles.cell, { width: 40, textAlign: 'center' }]}>{item2.height > 0 ? item2.height : ''}</Text>
                            <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 25 }]}>
                              {(() => {
                                let value = 0;

                                if (item2.area > 0) {
                                  value = item2.area;
                                } else if (item2.rft > 0) {
                                  value = item2.rft;
                                } else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                  // Cove light calculation
                                  value =
                                    (item2.width * item2.depth * 2) +
                                    ((item2.height - (item2.depth * 2)) * item2.depth * 2) +
                                    (
                                      (
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2)) +
                                        (item2.width - (item2.depth * 2)) +
                                        (item2.height - (item2.depth * 2))
                                      ) * 3
                                    );
                                } else if (item2.width > 0 && item2.height > 0) {
                                  value = item2.width * item2.height;
                                }

                                return value ? Number(value.toFixed(2)) : '';
                              })()}

                            </Text>

                          </>
                        )}

                        <Text style={[styles.cell, { width: 30, textAlign: 'center' }]}>{item2.qnty > 0 ? item2.qnty : ''}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 1 }]}>{item2.price > 0 ? item2.value : ''}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 1 }]}>{item2.price > 0 && item2.type == 'nonwoodwork' || item2.type == '' ? item2.value : item2.valueIncresed}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center' }]}>{item2.value}</Text>
                        <Text style={[styles.cell, { width: 50, textAlign: 'center', paddingLeft: 1 }]}>{item2.price > 0 && item2.type == 'woodwork' ? Math.round(item2.price -(item2.price * (e.quotationDiscount / 100))) : null}</Text>
                        <Text style={[styles.cell, { width: 70, flexWrap: 'wrap', textAlign: 'left' }]}>{item2.remark}</Text>
                      </View>
                      <View style={{ borderBottomColor: '#afafaf', borderBottomWidth: 0.5, marginVertical: 4 }} />
                    </View>
                  );
                }

                // 4️⃣ Default: skip
                return null;
              })}

              <View
                style={{
                  width: '100%',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  marginTop: 6,
                  marginBottom: 10,
                }}
              >
                <Text style={[styles.textBold2, { marginRight: 4 }]}>Total - </Text>
                <Text style={styles.textBold2}>{item.roomTypePrice}</Text>
              </View>
            </View>


          </View>
        ))}

      </Page>


      {/* Material Specifcations */}

      <Page size="A4" style={styles.page2} >
        {/* HEADER */}
        <View style={styles.header} fixed>
          <Image style={[styles.logo, { marginBottom: 4 }]} src={logo} />
          <Text style={[styles.text1, { marginBottom: 4 }]}>
            You are about to experience creativity and commitment at its best.
          </Text>
          <View style={{ borderBottomColor: '#afafaf', borderBottomWidth: 0.5, marginBottom: 12 }} />
        </View>

        {/* FOOTER */}
        <View style={styles.footer} fixed>
          <View
            style={{
              borderBottomColor: 'black',
              borderBottomWidth: 0.5,
              marginBottom: 5,
              marginTop: 5,
              width: '90%', // or use a fixed width like 200
              alignSelf: 'center', // to center the line horizontally
              paddingLeft: 10, // optional; remove if not needed
            }}
          />

          <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 35, }}>
            {/* Left Section */}
            <View style={{ paddingLeft: 35 }}>
              <Text style={[styles.textBold1]}>FABDIZ DESIGN STUDIO</Text>
              <Text style={[styles.text1]}>Bangalore | Kolkata | Chennai</Text>
              <Text style={[styles.text1, { marginTop: 2 }]}>GST: 29AAHFI9133P1ZM</Text>
            </View>

            {/* Divider */}
            <View style={{ borderLeftColor: 'black', borderLeftWidth: 0.5, marginLeft: 55, height: 45, paddingRight: 30, paddingLeft: 30 }} />

            {/* Right Section */}
            <View style={{ flex: 1, paddingLeft: 5 }}>
              <Image style={[styles.logo, { width: 80 }]} src={fabCuroLogo} />
              <Text style={[styles.text1, { flexShrink: 2, paddingLeft: 6 }]}>
                The premium decor store - a FABDIZ initiative. Now shipping pan India
              </Text>
              <Text
                style={[styles.text1, { fontSize: 10, fontWeight: 'bold', marginTop: 4 }]}
                render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
                fixed
              />
            </View>
          </View>
        </View>


        <View style={{ flexDirection: 'row', gap: 2, marginTop: 20, marginBottom: 20 }}>
          <View
            style={{
              borderBottomColor: '#ff6619',
              borderBottomWidth: 3,
              width: '10%',
              marginBottom: 6,
              marginRight: 12,
              marginLeft: 12,
            }}
          />
          <Text style={[styles.textBold2, { marginBottom: 3 }]}>
            Material Specifications
          </Text>
        </View>
        {/* Customber Details */}
        <View style={{ position: 'relative', width: '100%', marginBottom: 15 }}>
          {/* Shadow */}
          <View
            style={{
              position: 'absolute',
              top: 4,
              left: 13,
              width: '95%',
              backgroundColor: '#f0f0f0', // semi-transparent shadow
              borderRadius: 5,
              height: '100%',
              zIndex: 1,
            }}
          />


          <View
            style={{
              width: '95%',
              backgroundColor: '#ffffff',
              marginLeft: 10,
              borderRadius: 5,
              padding: 14,
              flexWrap: 'wrap',
              zIndex: 0,
            }}
          >

            <View style={[styles.cell]}>
              <Text style={{
                paddingBottom: 10,
                fontSize: 11
              }}>Laminate:</Text>
              <Text>(Merino, Greenlam, Century, Realtouch, Heritage, Royal Touch). External Matt Laminated Finish 1.0 mm (Any
                Brand - SF, upto Rs. 1200 per sheet), unless otherwise specified. Internal Matt finish laminate of 0.79-0.8 mm,
                Hazel Cambric/off white color, unless and otherwise specified.
              </Text>
            </View>
            <View style={{ borderBottomColor: 'black', borderBottomWidth: 0.5, marginBottom: 12, marginTop: 12 }} />
            <View style={[styles.cell]}>
              <Text style={{
                paddingBottom: 10,
                fontSize: 11
              }}>PLY:</Text>
              <Text>We use Century Sainik Ply. Kitchen, Utility and Washroom
                - Below Boxes in BWP (Water Proof) Ply - 16 mm (Calibrated). Kitchen above boxes, wardrobe, other units, such
                as crockery/display/loft unit etc. in MR (Moisture Resistant) Ply - 16 mm (Calibrated).

              </Text>
            </View>
            <View style={{ borderBottomColor: 'black', borderBottomWidth: 0.5, marginBottom: 12, marginTop: 12 }} />

            <View style={[styles.cell]}>
              <Text style={{
                paddingBottom: 10,
                fontSize: 11
              }}>Hardware:</Text>
              <Text>Hafele/Hettich/EBCO Hinges and other hardware (Tandem Box, Channels, Sliders etc) shall be of regular operations (Soft Close on Demand). Handles, Knobs, shall be of local supply (with basic rate of Rs. 100/pc 8 inch and Rs,
                50/Pc 4 inch) or as per selection . Wire-Baskets (Plate, thali, cutlery or bottle pullout) if any, shall be stainless steel
                (Local Supply) grade-304. Wicker Basket if any, will be local supply as per IS standards and size customizable.
                Kitchen Skirting shall be a PVC make of approved color and finish with PVC adjustable legs. 5mm plain glass for
                glass shutters, unless otherwise specified with wooden frame. (Aluminium shutters can be on demand). 6mm plain
                glass for Shelves ad per drawings or unless otherwise specified.
                Complimentary :- Handles/Knobs (upto 6 inch) from our selected board.
              </Text>
            </View>
            <View style={{ borderBottomColor: 'black', borderBottomWidth: 0.5, marginBottom: 12, marginTop: 12 }} />

            <View style={[styles.cell]}>
              <Text style={{
                paddingBottom: 10,
                fontSize: 11
              }}>Others:</Text>
              <Text>SS Shelf pins, Clamps, Screw and other fixtures - local supply. Dowels & Mini-fix - Hettich. Glue - Pedilite (Adhesive),
                Araldite, Jotun, Rehau, woodmaster or equivelent based on application. Edge Banding - Rehau or Equivalent (1mm
                or 2mm as per application).

              </Text>
            </View>
            <View style={{ borderBottomColor: 'black', borderBottomWidth: 0.5, marginBottom: 12, marginTop: 12 }} />

            <View style={[styles.cell]}>
              <Text style={{
                paddingBottom: 10,
                fontSize: 11
              }}>Paint, Polish & Powdercoat:</Text>
              <Text>As per selection (Asian, Dulux, Berger, RAL), only if mentioned in quote.</Text>
            </View>


          </View>
        </View>

      </Page>

      {/*TERMS AND CONDITIONS */}

      <Page size="A4" style={styles.page2}>
        {/* HEADER */}
        <View style={styles.header} fixed>
          <Image style={[styles.logo, { marginBottom: 4 }]} src={logo} />
          <Text style={[styles.text1, { marginBottom: 4 }]}>
            You are about to experience creativity and commitment at its best.
          </Text>
          <View style={{ borderBottomColor: '#afafaf', borderBottomWidth: 0.5, marginBottom: 12 }} />
        </View>

        {/* FOOTER */}
        <View style={styles.footer} fixed>
          <View
            style={{
              borderBottomColor: 'black',
              borderBottomWidth: 0.5,
              marginBottom: 5,
              marginTop: 5,
              width: '90%', // or use a fixed width like 200
              alignSelf: 'center', // to center the line horizontally
              paddingLeft: 10, // optional; remove if not needed
            }}
          />

          <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 35, }}>
            {/* Left Section */}
            <View style={{ paddingLeft: 35 }}>
              <Text style={[styles.textBold1]}>FABDIZ DESIGN STUDIO</Text>
              <Text style={[styles.text1]}>Bangalore | Kolkata | Chennai</Text>
              <Text style={[styles.text1, { marginTop: 2 }]}>GST: 29AAHFI9133P1ZM</Text>
            </View>

            {/* Divider */}
            <View style={{ borderLeftColor: 'black', borderLeftWidth: 0.5, marginLeft: 55, height: 45, paddingRight: 30, paddingLeft: 30 }} />

            {/* Right Section */}
            <View style={{ flex: 1, paddingLeft: 5 }}>
              <Image style={[styles.logo, { width: 80 }]} src={fabCuroLogo} />
              <Text style={[styles.text1, { flexShrink: 2, paddingLeft: 6 }]}>
                The premium decor store - a FABDIZ initiative. Now shipping pan India
              </Text>
              <Text
                style={[styles.text1, { fontSize: 10, fontWeight: 'bold', marginTop: 4 }]}
                render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
                fixed
              />
            </View>
          </View>
        </View>


        <View style={{ flexDirection: 'row', gap: 2, marginTop: 20, marginBottom: 20 }}>
          <View
            style={{
              borderBottomColor: '#ff6619',
              borderBottomWidth: 3,
              width: '10%',
              marginBottom: 6,
              marginRight: 12,
              marginLeft: 12,
            }}
          />
          <Text style={[styles.textBold2, { marginBottom: 3 }]}>
            TERMS AND CONDITIONS
          </Text>
        </View>
        {/* Customber Details */}
        <View style={{ position: 'relative', width: '100%', marginBottom: 15 }}>
          {/* Shadow */}
          <View
            style={{
              position: 'absolute',
              top: 4,
              left: 13,
              width: '95%',
              backgroundColor: '#f0f0f0', // semi-transparent shadow
              borderRadius: 5,
              height: '100%',
              zIndex: 1,
            }}
          />


          <View
            style={{
              width: '95%',
              backgroundColor: '#ffffff',
              marginLeft: 10,
              borderRadius: 5,
              padding: 14,
              zIndex: 0,
            }}
          >

            <View style={[styles.cell]} >
              <Text style={{
                paddingBottom: 10,
                fontSize: 11
              }}>Warranty :</Text>
              <Text>1. We provide 10 years warranty for plywood, This safeguards you against any defect in manufacturing or in installation
                workmanship under normal usage. Hardware warranty will be apllicable based on the brands chosen For custom
                work, there is no warranty applicable. For more information about warranty policy we suggest you to ask FABDIZ
                warranty policy to our Design consultant
              </Text>
              <Text>Note :1 year of free servicing for our product</Text>
              <Text>2. All accessories, hardware and appliances are covered as per the respective Manufacturers.</Text>
            </View>
            <View style={{ borderBottomColor: 'black', borderBottomWidth: 0.5, marginBottom: 12, marginTop: 12 }} />
            <View style={[styles.cell]} wrap={false}  >
              <Text style={{
                paddingBottom: 10,
                fontSize: 11
              }} >General terms :</Text>
              <Text style={{
                paddingBottom: 5
              }}>1. Chimney, Sink, Hob, Gas Piping, Granite along with the labour cost associated are not included in this quotation
                unless mentioned otherwise.</Text>
              <Text style={{
                paddingBottom: 5
              }}> 2. Light Fittings, Geyser, Bathroom Fittings, Fans and any other electrical fittings are not included in this quotation
                unless mentioned otherwise.</Text>
              <Text style={{
                paddingBottom: 5
              }}> 3. Any product that is not added in this Quotation has to be assumed as Non Tendered Product, a revised quote will
                be provided for the same. FABDIZ will only be responsible for work mentioned in the quotation.</Text>
              <Text style={{
                paddingBottom: 5
              }}>4. Alteration of the existing electrical wiring/points and plumbing wiring/points will be charged extra and for any civil
                changes like plumbing and wall chipping we need civil engineers for instructions.</Text>
              <Text style={{
                paddingBottom: 5
              }}> 5. FABDIZ execution team takes the responsibility of moving debris to Garbage Room of the apartment premises.</Text>
              <Text style={{
                paddingBottom: 5
              }}> 6. FABDIZ execution team takes the responsibility of cleaning floor & interiors before moving out of the site (Deep
                cleaning not included).</Text>
              <Text style={{
                paddingBottom: 5
              }}>7. Sliding Door Track fitting will bring 15-25mm gap between the Sliding Door and loft. As we need that gap during
                the maintenance. Sliding Door Track fitting will bring 10mm gap between the door overlapping.</Text>
              <Text style={{
                paddingBottom: 5
              }}>8. Product with glossy finish may have very less unevenness look and feel due to lighting effect.</Text>
              <Text style={{
                paddingBottom: 5
              }}> 9. This quotation will be valid for 1 month.</Text>
              <Text style={{
                paddingBottom: 5
              }}>10. Final coat of paint should be done after completion of interior work from client side We are unable to avoid
                handmarks, scratches during installation.
              </Text>
              <Text style={{
                paddingBottom: 5
              }}> 11. There will be difference between in handmade furniture and modular furniture. As handmade furniture by carpenters on site with hand tools so as compared to modular work handmade furniture finishing will differ</Text>
              <Text style={{
                paddingBottom: 5
              }}>12. Images shown in the 3d are for reference, please refer actual samples for colour selection and texture / wallpapers
                or any decor items which might be shown only for reference.
              </Text>
              <Text style={{
                paddingBottom: 5
              }}>13. Design alterations will not be considered once the design document is signed off or once FADBIZ get confirmation
                for design document through mail/electronic media
              </Text>
              <Text style={{
                paddingBottom: 5
              }}>14. Production date will start as per the schedule that will be shared.</Text>
              <Text style={{
                paddingBottom: 5
              }}>15. Any modifications at site should be informed to the designer and project manager prior to production.</Text>
              <Text style={{
                paddingBottom: 5
              }}>16. FABDIZ will not be responsible for products purchased from elsewhere.</Text>
              <Text style={{
                paddingBottom: 5
              }}>17. The Entertainment Cabinet and other modular cabinets more than 2400MM will be having two cabinets in that case
                the joint at the top of the cabinet will be visible.
              </Text>
            </View>
            {/* <View style={{ borderBottomColor: 'black', borderBottomWidth: 0.5, marginBottom: 12, marginTop: 12 }} /> */}

            <View style={[styles.cell]} wrap={false} >
              <Text style={{
                paddingBottom: 10,
                fontSize: 11
              }}>Design Process :</Text>
              <Text style={{
                paddingBottom: 5
              }}>1. Site Visit : Once booking advance paid Interior Designer will visit the client site with measurement team.</Text>
              <Text style={{
                paddingBottom: 5
              }}>2. Discussion Meeting: Designer will show the modular library, completed project photographs which will match to
                client requirement.
              </Text>
              <Text style={{
                paddingBottom: 5
              }}>3. Modeling Presentation: As per client requirement and placement of furniture designer will present modeling. (upto
                2 iteration can be done in the 3d model stage post that timelines may change as per additional design changes.
              </Text>
              <Text style={{
                paddingBottom: 5
              }}>4. 3D Design Presentation: will present 3D design which will have the texture selected by client.</Text>
              <Text style={{
                paddingBottom: 5
              }}>5. Site Validation: Validation will be done at site where FABDIZ will execute project. Designer will visit the site with
                Project Manager for Masking Measurement. Masking measurement will be possible only on cleaned floor.</Text>
            </View>
            <View style={{ borderBottomColor: 'black', borderBottomWidth: 0.5, marginBottom: 12, marginTop: 12 }} />

            <View style={[styles.cell]} wrap={false}>

              <Text
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  marginBottom: 12,
                }}
              >
                PAYMENT TERMS :
              </Text>

              <Text
                style={{
                  fontSize: 11,
                  marginBottom: 15,
                }}
              >
                Payments shall be made in accordance with the following schedule:
              </Text>

              {/* Table Header */}
              <View
                style={{
                  flexDirection: "row",
                  borderWidth: 1,
                  borderColor: "#000000",
                  backgroundColor: "#f5f5f5",
                }}
              >
                <Text
                  style={{
                    width: "25%",
                    borderRightWidth: 1,
                    borderColor: "#000000",
                    padding: 8,
                    fontSize: 11,
                    fontWeight: 700,
                    textAlign: "center",
                  }}
                >
                  Stage
                </Text>

                <Text
                  style={{
                    width: "20%",
                    borderRightWidth: 1,
                    borderColor: "#000000",
                    padding: 8,
                    fontSize: 11,
                    fontWeight: 700,
                    textAlign: "center",
                  }}
                >
                  Payment %
                </Text>

                <Text
                  style={{
                    width: "55%",
                    padding: 8,
                    fontSize: 11,
                    fontWeight: 700,
                    textAlign: "center",
                  }}
                >
                  Details
                </Text>
              </View>

              {/* Row 1 */}
              <View
                style={{
                  flexDirection: "row",
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderBottomWidth: 1,
                  borderColor: "#000000",
                }}
              >
                <Text style={styles.tableCellLeft}>Booking Amount</Text>
                <Text style={styles.tableCellCenter}>10%</Text>
                <Text style={styles.tableCellRight}>
                  Upon confirmation of project
                </Text>
              </View>

              {/* Row 2 */}
              <View
                style={{
                  flexDirection: "row",
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderBottomWidth: 1,
                  borderColor: "#000000",
                }}
              >
                <Text style={styles.tableCellLeft}>Milestone 1</Text>
                <Text style={styles.tableCellCenter}>20%</Text>
                <Text style={styles.tableCellRight}>
                  Upon material selection and approval of design quotation
                </Text>
              </View>

              {/* Row 3 */}
              <View
                style={{
                  flexDirection: "row",
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderBottomWidth: 1,
                  borderColor: "#000000",
                }}
              >
                <Text style={styles.tableCellLeft}>Milestone 2</Text>
                <Text style={styles.tableCellCenter}>20%</Text>
                <Text style={styles.tableCellRight}>
                  Upon site validation and prior to issuance of sign-off documents
                </Text>
              </View>

              {/* Row 4 */}
              <View
                style={{
                  flexDirection: "row",
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderBottomWidth: 1,
                  borderColor: "#000000",
                }}
              >
                <Text style={styles.tableCellLeft}>Milestone 3</Text>
                <Text style={styles.tableCellCenter}>100%</Text>
                <Text style={styles.tableCellRight}>
                  As per quotation provided by the Project Manager
                  (Civil/Electrical/Plumbing/Painting)
                </Text>
              </View>

              {/* Row 5 */}
              <View
                style={{
                  flexDirection: "row",
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderBottomWidth: 1,
                  borderColor: "#000000",
                }}
              >
                <Text style={styles.tableCellLeft}>Milestone 4</Text>
                <Text style={styles.tableCellCenter}>40%</Text>
                <Text style={styles.tableCellRight}>
                  Prior to dispatch of materials from factory
                </Text>
              </View>

              {/* Row 6 */}
              <View
                style={{
                  flexDirection: "row",
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderBottomWidth: 1,
                  borderColor: "#000000",
                }}
              >
                <Text style={styles.tableCellLeft}>Milestone 5</Text>
                <Text style={styles.tableCellCenter}>10%</Text>
                <Text style={styles.tableCellRight}>
                  Upon carcass installation and quality check
                </Text>
              </View>

              <Text
                style={{
                  marginTop: 12,
                  fontSize: 10,
                }}
              >
                GST 18% shall be charged additionally and shall be payable along
                with each milestone payment.
              </Text>
            </View>
            <View style={{ borderBottomColor: 'black', borderBottomWidth: 0.5, marginBottom: 12, marginTop: 12 }} />

            <View>
              <Text style={{
                paddingBottom: 10,
                fontSize: 11
              }}>PAYMENT METHOD :</Text>
            </View>

            <View style={styles.row} wrap={false}>

              <View style={styles.column2}>

                <View style={{ flexDirection: 'row', margin: 10, paddingBottom: 10, borderBottomColor: '#bdbdbd', borderBottomWidth: 1, borderBottomStyle: 'dashed' }}>
                  <View style={{ flex: 7, flexDirection: 'column' }}>
                    <Text style={{ fontSize: 10, color: '#2F2E2E', fontWeight: 'bold' }}>Favouring Name</Text>
                  </View>
                  <View style={{ flex: 5, flexDirection: 'row-reverse' }}>

                    <Text style={{ fontSize: 10, color: '#2F2E2E' }}>INBUILT CONCEPTS</Text>
                  </View>
                </View>
                <View style={{ flexDirection: 'row', margin: 10, paddingBottom: 10, borderBottomColor: '#bdbdbd', borderBottomWidth: 1, borderBottomStyle: 'dashed' }}>
                  <View style={{ flex: 7, flexDirection: 'column' }}>
                    <Text style={{ fontSize: 10, color: '#2F2E2E', fontWeight: 'bold' }}>Bank Name</Text>
                  </View>
                  <View style={{ flex: 5, flexDirection: 'row-reverse' }}>

                    <Text style={{ fontSize: 10, color: '#2F2E2E' }}>{bankDetails?.bankName}</Text>
                  </View>
                </View>
                <View style={{ flexDirection: 'row', margin: 10, paddingBottom: 10, borderBottomColor: '#bdbdbd', borderBottomWidth: 1, borderBottomStyle: 'dashed' }}>
                  <View style={{ flex: 7, flexDirection: 'column' }}>
                    <Text style={{ fontSize: 10, color: '#2F2E2E', fontWeight: 'bold' }}>Cash Credit Account No.</Text>
                  </View>
                  <View style={{ flex: 5, flexDirection: 'row-reverse' }}>

                    <Text style={{ fontSize: 10, color: '#2F2E2E' }}>{bankDetails?.accountNo}</Text>
                  </View>
                </View>
                <View style={{ flexDirection: 'row', margin: 10, paddingBottom: 10, borderBottomColor: '#bdbdbd', borderBottomWidth: 1, borderBottomStyle: 'dashed' }}>
                  <View style={{ flex: 7, flexDirection: 'column' }}>
                    <Text style={{ fontSize: 10, color: '#2F2E2E', fontWeight: 'bold' }}>Branch</Text>
                  </View>
                  <View style={{ flex: 5, flexDirection: 'row-reverse' }}>

                    <Text style={{ fontSize: 10, color: '#2F2E2E' }}>{bankDetails?.branchName}</Text>
                  </View>
                </View>

                <View style={{ flexDirection: 'row', padding: 10 }}>
                  <View style={{ flex: 7, flexDirection: 'column' }}>
                    <Text style={{ fontSize: 10, color: '#2F2E2E', fontWeight: 'bold' }}>IFSC Code</Text>
                  </View>
                  <View style={{ flex: 5, flexDirection: 'row-reverse' }}>

                    <Text style={{ fontSize: 10, color: '#2F2E2E' }}>{bankDetails?.ifsc}</Text>
                  </View>
                </View>

              </View>

              <View style={styles.column3}>
                <Image style={styles.scan2} src={bankDetails?.image} />
              </View>
            </View>


          </View>
        </View>
        {/* FOOTER */}
        {/* <View style={[styles.footer]}>
          <View
            style={{
              borderBottomColor: 'black',
              borderBottomWidth: 0.1,
              width: '100%',
              marginBottom: 6,
              marginRight: 12,
              marginLeft: 12,
            }}
          />
          <View style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
          }} >
            <View style={{
              paddingLeft: 35,
            }}>
              <Text style={[styles.textBold1]}>FABDIZ DESIGN STUDIO</Text>
              <Text style={[styles.text1]}>Bangalore | Kolkata | Chennai</Text>
              <Text style={[styles.text1, { marginTop: 5 }]}>GST: 29AAHFI9133P1ZM</Text>
            </View>
            <View
              style={{
                borderLeftColor: 'black',
                borderLeftWidth: 0.5,
                marginLeft: 55,
                height: 45, // Adjust the height as needed
                marginHorizontal: 25, // Optional: adds horizontal spacing
              }}
            />

            <View style={{ width: '40vw', padding: 1 }}>
              <Image style={[styles.logo, { width: 100 }]} source={logo} />
              <Text style={[styles.text1, { flexShrink: 1, marginTop: 1 }]}>
                The premium decor store - a FABDIZ initiative. Now shipping pan India
              </Text>
            </View>
          </View>
        </View> */}
      </Page>

    </Document>


  )
}
